import React from "react";
import { DailogBox } from "./DailogBox";
import { ReactComponent as GreenTick } from "../../../assets/svgs/greenTick.svg";
import { ReactComponent as CloudIcon } from "../../../assets/svgs/approved.svg";
import { ReactComponent as InActive } from "../../../assets/svgs/inActive.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svgs/deleteIcon.svg";
import { ReactComponent as Document } from "../../../assets/svgs/document.svg";
import { message } from "antd";

const SuccessDailogBox = ({
  onOpen,
  onClose,
  successMessage,
  messageTitle,
  popuptype = "success",
}) => {
  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="530px">
        {popuptype === "success" && (
          <div className="py-4 text-center">
            <div className="py-2">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#E4F5F9] flex items-center justify-center shadow-md">
                <GreenTick />
              </div>
            </div>
            <div>Success!</div>
            <div>
              <p>{successMessage}</p>
            </div>
          </div>
        )}
        {popuptype === "failed" && (
          <div className="py-4 text-center">
            <div className="py-2">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#E4F5F9] flex items-center justify-center shadow-md">
                <span className="text-red-600 text-3xl">❌</span>
              </div>
            </div>
            <div className=" text-[17px]  font-[350] ">{messageTitle}</div>
            <div className="flex justify-center mt-2">
              <p className="text-sm font-light w-[400px]">{successMessage}</p>
            </div>
          </div>
        )}
        {popuptype === "in-active" && (
          <div className="py-4 text-center">
            <div className="py-2">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#E4F5F9] flex items-center justify-center shadow-md">
                <InActive />
              </div>
            </div>
            <div className=" text-[17px]  font-[350] ">{messageTitle}</div>
            <div className="flex justify-center mt-2">
              <p className="text-sm font-light w-[400px]">{successMessage}</p>
            </div>
          </div>
        )}
        {popuptype === "approved" && (
          <div className="py-4 text-center">
            <div className="py-2">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#E4F5F9] flex items-center justify-center shadow-md">
                <CloudIcon />
              </div>
            </div>
            <div className=" text-[17px]  font-[350] ">{messageTitle}</div>
            <div className="flex justify-center mt-2">
              <p className="text-sm font-light w-[400px]">{successMessage}</p>
            </div>
          </div>
        )}
        {popuptype === "delete" && (
          <div className="py-4 text-center">
            <div className="py-2">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#E4F5F9] flex items-center justify-center shadow-md">
                <DeleteIcon />
              </div>
            </div>
            <div className=" text-[17px]  font-[350] ">{messageTitle}</div>
            <div className="flex justify-center mt-2">
              <p className="text-sm font-light w-[400px]">{successMessage}</p>
            </div>
          </div>
        )}
        {popuptype === "document" && (
          <div className="py-4 text-center">
            <div className="py-2">
              <div className="w-16 h-16 mx-auto rounded-full bg-[#E4F5F9] flex items-center justify-center shadow-md">
                <Document />
              </div>
            </div>
            <div className=" text-[17px]  font-[350] ">{messageTitle}</div>
            <div className="flex justify-center mt-2">
              <p className="text-sm font-light w-[400px]">{successMessage}</p>
            </div>
          </div>
        )}
      </DailogBox>
    </div>
  );
};

export default SuccessDailogBox;
